/**
 * 支付成功时的活动清场入口（Hosted 回跳 / 站内 Sheet 共用）
 *
 * 有 activity_id 则 completeActivity；无则 no-op。
 * 业务页不要在 paymentSuccessSignal 里猜活动再清场。
 */

import { completeActivity } from './complete-activity';

/**
 * 支付成功且订单带活动时清场活动状态。
 * @param activityId 创单写入的 activity_id；空则跳过
 */
export function onActivityPaymentSuccess(activityId?: string): void {
    const id = activityId?.trim();
    if (!id) {
        return;
    }
    completeActivity(id);
}
